const STORAGE_KEY = 'lasmari-consent-v1';
const CHANGE_EVENT = 'lasmari-consent-change';
const FORCE_OPEN_KEY = 'lasmari-consent-force-open';

// IANA timezones for EEA + UK + CH — used to decide whether to auto-show the
// banner. Outside the EEA the granted default holds and the user can opt out
// via the footer "Do Not Sell or Share My Personal Information" link (CCPA).
const EEA_PLUS_TIMEZONES = new Set([
  'Europe/Vienna', 'Europe/Brussels', 'Europe/Sofia', 'Europe/Zagreb',
  'Europe/Nicosia', 'Asia/Famagusta', 'Europe/Prague', 'Europe/Copenhagen',
  'Europe/Tallinn', 'Europe/Helsinki', 'Europe/Paris', 'Europe/Berlin',
  'Europe/Busingen', 'Europe/Athens', 'Europe/Budapest', 'Atlantic/Reykjavik',
  'Europe/Dublin', 'Europe/Rome', 'Europe/Riga', 'Europe/Vaduz',
  'Europe/Vilnius', 'Europe/Luxembourg', 'Europe/Malta', 'Europe/Amsterdam',
  'Europe/Oslo', 'Europe/Warsaw', 'Europe/Lisbon', 'Atlantic/Madeira',
  'Atlantic/Azores', 'Europe/Bucharest', 'Europe/Bratislava', 'Europe/Ljubljana',
  'Europe/Madrid', 'Atlantic/Canary', 'Europe/Stockholm', 'Europe/London',
  'Europe/Belfast', 'Europe/Guernsey', 'Europe/Isle_of_Man', 'Europe/Jersey',
  'Europe/Zurich',
]);

export function isLikelyEEA() {
  if (typeof window === 'undefined') return false;
  try {
    return EEA_PLUS_TIMEZONES.has(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch {
    return true; // fail-safe to EEA (errs on GDPR compliance)
  }
}

export function hasGPCSignal() {
  if (typeof window === 'undefined') return false;
  return navigator.globalPrivacyControl === true;
}

export function isBannerForceOpen() {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem(FORCE_OPEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function openConsentPreferences() {
  try { sessionStorage.setItem(FORCE_OPEN_KEY, '1'); } catch {}
  clearConsent();
}

function clearForceOpen() {
  try { sessionStorage.removeItem(FORCE_OPEN_KEY); } catch {}
}

export function getConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function subscribeToConsent(cb) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(CHANGE_EVENT, cb);
  window.addEventListener('storage', cb);
  return () => {
    window.removeEventListener(CHANGE_EVENT, cb);
    window.removeEventListener('storage', cb);
  };
}

export function saveConsent(analytics, ads) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      ad_storage: ads ? 'granted' : 'denied',
      ad_user_data: ads ? 'granted' : 'denied',
      ad_personalization: ads ? 'granted' : 'denied',
      analytics_storage: analytics ? 'granted' : 'denied',
    });
  }
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ analytics, ads, timestamp: new Date().toISOString() }),
    );
  } catch {}
  clearForceOpen();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(CHANGE_EVENT));
  }
}

export function clearConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(CHANGE_EVENT));
  }
}
